import { useContext } from 'react';
import { Modal } from 'antd';
import { DeliveryContext } from '@CONTEXTS';

const PrintModal = () => {
  const { printModal, dispatch } = useContext(DeliveryContext);

  return (
    <Modal
      visible
      title="Barkod Yazdır"
      maskClosable={false}
      centered
      width={950}
      onCancel={() => {
        dispatch({ type: 'SET_PRINT_MODAL', payload: false });
      }}
      footer={false}
    >
      <iframe
        src={`data:application/pdf;base64,${printModal}`}
        title="Barkod"
        style={{ width: '100%', height: 600, border: 'none' }}
      />
    </Modal>
  );
};

export default PrintModal;
